export default __webpack_public_path__ + "static/media/robson.b14caf2b.png";